import { render, staticRenderFns } from "./xpscarrier.vue?vue&type=template&id=4782babd"
import script from "./xpscarrier.vue?vue&type=script&lang=js"
export * from "./xpscarrier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports